"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCandle = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M11.751 2.367C11.813 2.282 12 2 12 2l.249.367.158.222c.113.158.233.327.363.506.894 1.222 2.23 3.057 2.23 4.11 0 .77-.34 1.467-.883 1.973A3.1 3.1 0 0112 10a3.141 3.141 0 01-2.117-.812C9.339 8.682 9 7.986 9 7.217c0-1.055 1.336-2.9 2.23-4.122.204-.275.374-.507.521-.728zM4 21a1 1 0 011-1h4v-7a2 2 0 012-2h2a2 2 0 012 2v7h4a1 1 0 011 1v1H4v-1z' }))); };
exports.default = SvgCandle;
//# sourceMappingURL=Candle.js.map